import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { UiFormTooltipIcon } from "@webapp/ui/form/form.models";

@Component({
  selector: "gh-example-form-component",
  templateUrl: "./example-form.component.html",
  styleUrls: ["./example-form.component.less"],
})
export class ExampleFormComponent implements OnInit {
  public validateForm!: FormGroup;
  public captchaTooltipIcon: UiFormTooltipIcon = {
    type: "info-circle",
    theme: "twotone",
  };

  public constructor(private fb: FormBuilder) {}

  public ngOnInit(): void {
    this.validateForm = this.fb.group({
      email: [null, [Validators.email, Validators.required]],
      password: [null, [Validators.required]],
      checkPassword: [null, [Validators.required, this.confirmationValidator]],
      nickname: [null, [Validators.required]],
      phoneNumberPrefix: ["+86"],
      phoneNumber: [null, [Validators.required]],
      website: [null, [Validators.required]],
      captcha: [null, [Validators.required]],
      agree: [false],
    });
  }
  public submitForm(): void {
    if (this.validateForm.valid) {
      // eslint-disable-next-line no-console
      console.log("submit", this.validateForm.value);
    } else {
      Object.values(this.validateForm.controls).forEach((control: AbstractControl) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  public updateConfirmValidator(): void {
    /** wait for refresh value */
    Promise.resolve().then(() => this.validateForm.controls.checkPassword.updateValueAndValidity());
  }

  public confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.validateForm.controls.password.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  public getCaptcha(e: MouseEvent): void {
    e.preventDefault();
  }
}
